import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from 'react-router';
import config from "../config";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const styles = (theme) => ({
  root: {
    // display: 'flex',
  },
  problem: {
    width: "100%",
  },
});
class ProblemView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      answers: [],
      status: [],
    };
  }
  componentDidMount() {
    return fetch(config.backend_url + "contests/" + this.props.contest_id + "/problems").then(
      (response) => {
        response.json().then((json) => {
          this.setState({ results: json, loading: false });
        });
      }
    );
  }

  onClick = (idx) => (e) => {
    e.preventDefault();
    if (!this.props.user_id) {
      this.props.history.push("/login");
      return;
    }
    if (this.state.answers[idx] === 'none' || !this.state.answers[idx]) {
      return; 
    }
    fetch(config.backend_url + "new/answer", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({
        problem_id: this.state.results.problems[idx].id,
        user_id: this.props.user_id,
        answer: this.state.answers[idx],
      }),
    }).then((response) => {
      response.json().then((json) => {
        const status = this.state.status;
        status[idx] = json.status;
        this.setState({ status: status });
      });
    });
  };
  onChange = (idx) => (e) => {
    const status = this.state.status;
    status[idx] = null;
    const answers = this.state.answers;
    answers[idx] = e.target.value;
    this.setState({ answers: answers, status: status });
  };
  render() {
    const { classes } = this.props;
    if (this.state.loading) {
      return <p>Loading...</p>;
    }
    if (this.state.results.problems == null) {
      return <p>コンテスト開始前です</p>;
    }
    return (
      <div className={classes.root}>
        {(this.state.results.problems !== null
          ? this.state.results.problems
          : []
        ).map((problem, idx) => {
          return (
            <Card key={idx}>
              <CardContent>
                <div align="center">
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                  >
                    {problem.title}
                  </Typography>

                  <img className={classes.problem} src={problem.image_url} alt="謎"></img>
                  <form>
                    {problem.type === 'FREE_WORD' ? <React.Fragment>
                    <TextField
                      id={"answer-" + problem.id}
                      onChange={this.onChange(idx)}
                      label="回答"
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={this.onClick(idx)}
                    >
                      送信
                    </Button>
                    </React.Fragment>
                    :
                    <React.Fragment>
                    <center><Alert severity="warning">選択問題は一度しか回答できません。</Alert></center>
                    <Select
                      labelId="answer-label"
                      onChange={this.onChange(idx)}
                      defaultValue={'none'}
                    >
                      <MenuItem value={'none'}>選択肢</MenuItem>
                      <MenuItem value={'A'}>A</MenuItem>
                      <MenuItem value={'B'}>B</MenuItem>
                      <MenuItem value={'C'}>C</MenuItem>
                      <MenuItem value={'D'}>D</MenuItem>
                    </Select>
                    
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={this.onClick(idx)}
                    >
                      送信
                    </Button>
                    </React.Fragment>
        }
                  </form>
                </div>
                {this.state.status[idx] === 'wrong' && (
                  <Alert severity="error">不正解</Alert>
                )}
                {this.state.status[idx] === 'correct' && (
                  <Alert severity="success">正解</Alert>
                )}
                {this.state.status[idx] === "unknown" && (
                    <Alert severity="info">送信しました。正否はコンテスト終了時に順位表にて公開します。</Alert>
                )}
                {this.state.status[idx] === 'duplicate' && (
                    <Alert severity="error">送信に失敗しました。選択問題は一度までしか回答できません。</Alert>
                )}
              </CardContent>
            </Card>
          );
        })}

      </div>
    );
  }
}


ProblemView.propTypes = {
  contest_id: PropTypes.string.isRequired,
  user_id: PropTypes.string,
};

export default withRouter(withStyles(styles)(ProblemView));
